module.exports = __webpack_public_path__ + "media/images/cardboard-bg-01-3469aee167a577d6010d0a8e9a5bb583.svg";